import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30fb92e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Loading... ")

import { ref, watch } from 'vue';
import { PageState } from 'primevue/paginator';
import { DataTableSortEvent } from 'primevue/datatable';

import i18n from '@/locale/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'XDataTable',
  props: {
    pageSize: {
        type: Number,
        default: 10
    },
    paginatorShow: {
        type: Boolean,
        default: false
    },
    pageTotal: {
        type: Number,
        default: 0
    }
},
  emits: ['paginationChanged', 'handleSort'],
  setup(__props, { emit }) {

const props = __props

const t = i18n.global.t;



const rows = ref(props.pageSize);
const totalRecords = ref(props.pageTotal);
const paginatorShow = ref(props.paginatorShow);

watch(()=>props.pageSize, (newVal)=>{
    rows.value = newVal;
})

watch(()=>props.pageTotal, (newVal)=>{
    totalRecords.value = newVal;
})

watch(()=>props.paginatorShow, (newVal)=>{
    paginatorShow.value = newVal;
})



const pageOnChanged = (event: PageState) => {
    const { page, rows } = event;
    emit('paginationChanged', page + 1, rows);
}


return (_ctx: any,_cache: any) => {
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    (paginatorShow.value)
      ? (_openBlock(), _createBlock(_component_Paginator, {
          key: 0,
          class: "justify-content-start",
          rows: rows.value,
          totalRecords: totalRecords.value,
          rowsPerPageOptions: [10, 30, 50],
          onPage: pageOnChanged
        }, null, 8, ["rows", "totalRecords"]))
      : _createCommentVNode("", true),
    _createVNode(_component_DataTable, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), {
      empty: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("COMMON.DATATABLE.TABLE_NO_RESULT")), 1)
      ]),
      loading: _withCtx(() => [
        _hoisted_1
      ]),
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 16)
  ]))
}
}

})